import {
  Box,
  Chip,
  CircularProgress,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { CategoryConfig } from "../../config/categories-config";
import CategoryInfoTooltip from "./category-info-tooltip";

interface CategoryListItemProps {
  category: CategoryConfig & { count: number };
  isSelected: boolean;
  isDragOver: boolean;
  background: string | undefined;
  isLoading: boolean;
  onSelect: () => void;
  onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
}

const CategoryListItem: React.FC<CategoryListItemProps> = ({
  category,
  isSelected,
  isDragOver,
  background,
  isLoading,
  onSelect,
  onDragOver,
  onDragLeave,
  onDrop,
}) => {
  return (
    <ListItemButton
      selected={isSelected}
      onClick={onSelect}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      sx={{
        borderRadius: 1,
        p: 1,
        background,
        height: 48,
        borderBottom: "1px solid #eee",
        transition: "background-color 0.2s",
        border: isDragOver ? "2px dashed #3AB49A" : "2px solid transparent",
      }}
    >
      <ListItemIcon sx={{ minWidth: 38 }}>{category.icon}</ListItemIcon>
      <ListItemText
        primary={
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: 0.25,
            }}
          >
            <span>{category.label}</span>
            <CategoryInfoTooltip
              description={category.description}
              example={category.example}
            />
          </Box>
        }
      />
      <Chip
        label={
          isLoading ? (
            <CircularProgress size={12} color="inherit" />
          ) : (
            category.count
          )
        }
        color={isSelected ? "success" : "default"}
        size="small"
        sx={{ fontWeight: 700, minWidth: 36 }}
      />
    </ListItemButton>
  );
};

export default CategoryListItem;
